import { CrmFieldResponse, LookupResponse, PicklistResponse } from '../../../common/interfaces';

export interface VehicleOffersEventDescriptionsResponse {
  attributes: VehicleOffersEventDescriptionResponse;
}

export interface VehicleOffersEventDescriptionBase {
  uds_app_status_filter_value: CrmFieldResponse<PicklistResponse<string, AppStatusFilterValues>>;
  uds_fahrzeugbestellungeneventdescriptionid: string;
  uds_hierarchie: CrmFieldResponse<number>;
  uds_name: CrmFieldResponse;
  uds_statusfahrer: CrmFieldResponse<PicklistResponse>;
  uds_statusfahrerkonfigurationen: CrmFieldResponse<PicklistResponse>;
  uds_statusfahzeugbestellfreigeber: CrmFieldResponse<PicklistResponse>;
  uds_statusfuhrparkleiter: CrmFieldResponse<PicklistResponse>;
}

export interface VehicleOffersEventDescriptionResponse extends VehicleOffersEventDescriptionBase {
  webroles: EventDescriptionWebRolesResponse[];
}

export interface VehicleOffersEventDescription extends VehicleOffersEventDescriptionBase {
  webroles: EventDescriptionWebRoles[];
  eventsCount?: number;
}

export interface EventDescriptionWebRolesResponse {
  attributes: EventDescriptionWebRoles;
}

export interface EventDescriptionWebRoles {
  eventId: string;
  uds_app_status_text: CrmFieldResponse;
  uds_app_status_text_when_done: CrmFieldResponse;
  uds_apppageid: CrmFieldResponse<LookupResponse>;
  uds_b2c_webrollid: CrmFieldResponse<LookupResponse>;
  uds_name: CrmFieldResponse;
  uds_show_in_appcode: CrmFieldResponse<PicklistResponse>;
  uds_vehicleordereventwebrollsid: string;
}

export enum AppStatusFilterValues {
  Configuration = 100000000, // Konfiguration
  ConfigurationRequested = 100000001, // Konfiguration angefordert
  CashPriceFeasibilityAssessment = 100000002, // Barpreis- & Baubarkeitsprüfung
  LeasingOffers = 100000003, // Leasingangebote
  Approval = 100000004, // Freigabe
  Order = 100000005, // Bestellung
  Archived = 100000006 // Archiviert
}
